import { render, staticRenderFns } from "./SmsDetailsContainer.vue?vue&type=template&id=5c67625a"
import script from "./SmsDetailsContainer.vue?vue&type=script&lang=js"
export * from "./SmsDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports